import { Text, Card, Flex, Heading, IconButton, Button, useToast } from '@chakra-ui/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { FC } from 'react';

import CloseIcon from '@/assets/icons/ic-close.svg';

import { ChatProfile } from '@/components/ui/shared/chat/ChatPopup/components/types';
import { IToastType } from '@/enums/ToastType';
import { useStores } from '@/hooks/useStores';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';
import { blockedUserQueryOptions } from '@/queries/upgrade/thinProfiles';

interface IBlockUser {
  onClose: () => void;
  profile: ChatProfile;
}

export const BlockUser: FC<IBlockUser> = ({ onClose, profile }) => {
  const { store } = useStores();
  const { data: session } = useQuery(sessionQueryOptions());
  const main_profile = session?.main_profile;
  const toast = useToast();
  const queryClient = useQueryClient();

  // This query is just for cache invalidation purposes
  useQuery(blockedUserQueryOptions(main_profile?.id, profile.user?.id));

  async function blockUser() {
    try {
      await store.request(`thin_profiles/${profile.id}/block_in_event_chats`, 'POST', {
        data: {
          type: 'thin_profiles',
          attributes: {},
        },
      });

      queryClient.invalidateQueries({ queryKey: ['thin-profiles', main_profile?.id, 'blocked'] });
      onClose();
    } catch (e) {
      toast({ status: IToastType.ERROR, title: 'Error' });
    }
  }

  return (
    <Flex
      backgroundColor="rgba(0, 0, 0, 0.8)"
      zIndex="10"
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Card w="290px" p={6}>
        <Flex flexDirection="column">
          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
            <Heading fontSize="xl">Block User</Heading>
            <IconButton
              size="xs"
              onClick={() => onClose()}
              aria-label="Close"
              ml="2"
              variant="unstyled"
              icon={<CloseIcon width="24px" />}
            />
          </Flex>
          <Text my={4}>
            Blocking this user will delete your chat history, and this action can’t be undone. You can unblock the user
            anytime from your profile.
          </Text>
          <Flex>
            <Button onClick={() => blockUser()} size="sm" colorScheme="black">
              Block user
            </Button>
            <Button onClick={() => onClose()} size="sm" variant="black">
              Cancel
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};
